import React, { useState, useEffect } from "react"
import stylesheet from "./product.module.css"
import Product_image from "../../../assets/images/weed_product.webp"
import {Link} from "react-router-dom"
import { getTheme } from "../../../actions/localtheme";
import { connect } from "react-redux";






const ProductCard = (props) => {
    

const [gamechange,setgamechange] = useState("")
useEffect(() => {
    props.getTheme()
    setgamechange(props.ThemeReducer.theme)
}, [gamechange]);
    return (
        <div className={stylesheet.main_card}>
            <div  style={{background:props.ThemeReducer.theme}} onClick={()=>props.Addcart()} className={stylesheet.add_to_cart_btn}>
                <img src="https://img.icons8.com/windows/32/FFFFFF/shopping-bag-full.png" />
            </div>
            <div className={stylesheet.card_left}>
                <div className={stylesheet.inner_image}>
                    <span style={{background:props.ThemeReducer.theme}}></span>
                    <img className={stylesheet.proimg} src={props.image} alt="" />
                </div>
            </div>
            <div className={stylesheet.card_right}>
                <Link to={props.link}>
                <h5 style={{color:props.ThemeReducer.theme}} onClick={()=>props.func()}>{props.title}</h5>
                </Link>
                <p>{props.description}</p>
                <h6 style={{color:props.ThemeReducer.theme}}>${props.price}</h6>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    ThemeReducer: state.ThemeReducer,
});

const mapDispatchToProps = (dispatch) => ({
    getTheme: (theme) =>
        dispatch(getTheme(theme)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ProductCard);